import { Link } from '@tanstack/react-router'
import * as m from '~/paraglide/messages'
import { Button } from '~/shared/ui/button'

export function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-primary">404</h1>
        <h2 className="mt-4 text-3xl font-semibold">{m.pageNotFound()}</h2>
        <p className="mt-2 text-muted-foreground">{m.pageNotFoundDescription()}</p>
        <div className="mt-8">
          <Button asChild>
            <Link to="/">{m.goBackHome()}</Link>
          </Button>
        </div>
      </div>
    </div>
  )
}
